module.exports = __webpack_public_path__ + "img/ins-copy.3744234e.svg";